import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import FiltroFacturacionMaquinaria from "./FiltroFacturacionMaquinaria";
import { useBox } from "./Helper/useBox";
import { GetKey } from "./Actions/GetContainer";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { color } from "echarts";
import { Visibility } from "@mui/icons-material";
// import DetalleFacturacionModal from "./DetalleFacturacionModal";
// import EditarModeloModal from "./EditarModeloModal";
import EditNoteIcon from "@mui/icons-material/EditNote";

export const DetalleFacturacionAcumuladoScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [facturaciones, setFacturacion] = useState([])
    // const [boxstate, setBoxState] = useBox();
    const [openModalFacturacion, setOpenModalFacturacion] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    // const [selectedNip, setSelectedNip] = useState('');
    // const [selectedID, setSelectedID] = useState('');
    // const [selectedNipEdit, setSelectedNipEdit] = useState('');
    // const [selectedNEconomico, setSelectedNEconomico] = useState('');

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const keyCounts = {};

    const getKey = (fac) => {
        const keyBase = `${fac.nip}-${fac.fecha_venta}-${fac.primera_venta}-${fac.cancelado}`;

        if (keyCounts[keyBase]) {
            keyCounts[keyBase] += 1;
        } else {
            keyCounts[keyBase] = 1;
        }

        return `${keyBase}-${keyCounts[keyBase]}`;
    };

    // const handleOpenModalFacturacion = (nip) => {
    //     setSelectedNip(nip);
    //     setOpenModalFacturacion(true);
    // };

    // const handleCloseModalFacturacion = () => {
    //     setLoader({ ...loader, mostrar: true });
    //     onExecute(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    //     setLoader({ ...loader, mostrar: false });
    //     setOpenModalFacturacion(false);
    //     setSelectedNip(null);
    // };

    // const handleOpenModalEditar = (id, nip, neco) => {
    //     setSelectedID(id);
    //     setSelectedNipEdit(nip)
    //     setSelectedNEconomico(neco)
    //     setOpenModalEditar(true);
    // };

    // const handleCloseModalEditar = () => {
    //     setLoader({ ...loader, mostrar: true });
    //     onExecute(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    //     setLoader({ ...loader, mostrar: false });
    //     setOpenModalEditar(false);
    //     setSelectedID(null);
    // };

    const nombreVendedor = Array.isArray(state.boxstate.pv.vendedor) && state.boxstate.pv.vendedor.length === 1
        ? state.boxstate.pv.vendedor[0]?.vendedor
            .replace(/ñ/g, "?")
            .trim()
            .replace(/\s+/g, " ")
        : "0";

    const meses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const ejercicioinicio = state.boxstate.ejercicioinicio;
    const periodoinicio = state.boxstate.periodoinicio;
    const ejerciciofin = state.boxstate.ejerciciofin;
    const periodofin = state.boxstate.periodofin;

    const nombreMesInicio = meses[periodoinicio - 1];
    const nombreMesFin = meses[periodofin - 1];

    useEffect(() => {
        // setLoader({ ...loader, mostrar: true });
        onExecute(ejercicioinicio, periodoinicio, ejerciciofin, periodofin, state.linea, nombreVendedor);
        // setLoader({ ...loader, mostrar: false });
    }, []);

    // console.log(state.boxstate.pv.sucursal)

    const onExecute = (ejercicioinicio, periodoinicio, ejerciciofin, periodofin, linea, vendedor) => {
        var sucursales = GetKey(state.boxstate.pv.sucursal, ["idSucursal"]);
        var adr = GetKey(state.boxstate.pv.adr, ["idEstado"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `DetalleFacturacionScorecard/Acumulado?linea=${linea}&ejercicioinicio=${ejercicioinicio}&periodoinicio=${periodoinicio}&ejerciciofin=${ejerciciofin}&periodofin=${periodofin}&adr=${adr}&sucursal=${sucursales}&vendedor=${vendedor}`
                )
                .then((result) => {
                    setFacturacion(result)
                    setLoader({ ...loader, mostrar: false });
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const boxstateToSave = {
        ...state.boxstate,
        pv: {
            ...state.boxstate.pv,
            sucursal: Array.isArray(state.boxstate.pv.sucursal) && state.boxstate.pv.sucursal.length === 1
                ? [{ ...state.boxstate.pv.sucursal[0], sucursal: capitalizeWords(state.boxstate.pv.sucursal[0].sucursal) }]
                : []  // Si hay 0 o más de 1 sucursal, se guarda como vacío
        }
    };

    const onGeneraExcel = (ejercicioinicio, periodoinicio, ejerciciofin, periodofin, linea, vendedor) => {
        var sucursales = GetKey(state.boxstate.pv.sucursal, ["idSucursal"]);
        var adr = GetKey(state.boxstate.pv.adr, ["idEstado"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        setLoader({ ...loader, mostrar: true });
        request
            .get(`DetalleFacturacionScorecard/ImprimirExcelAcumulado?linea=${linea}&ejercicioinicio=${ejercicioinicio}&periodoinicio=${periodoinicio}&ejerciciofin=${ejerciciofin}&periodofin=${periodofin}&adr=${adr}&sucursal=${sucursales}&vendedor=${vendedor}`)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${filename}.xlsx`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
            });
    };

    const onGeneraPDF = (ejercicioinicio, periodoinicio, ejerciciofin, periodofin, linea, vendedor) => {
        var sucursales = GetKey(state.boxstate.pv.sucursal, ["idSucursal"]);
        var adr = GetKey(state.boxstate.pv.adr, ["idEstado"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        setLoader({ ...loader, mostrar: true });
        request
            .get(`DetalleFacturacionScorecard/ImprimirPDFAcumulado?linea=${linea}&ejercicioinicio=${ejercicioinicio}&periodoinicio=${periodoinicio}&ejerciciofin=${ejerciciofin}&periodofin=${periodofin}&adr=${adr}&sucursal=${sucursales}&vendedor=${vendedor}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };


    const onRegresar = () => {
        localStorage.setItem('DatosFiltro', JSON.stringify(boxstateToSave));
        history.push("/Ventas/DashboardScorecardGerente");
    };

    return (
        <PlantillaScreen
            titulo={`FACTURACIÓN DE MAQUINARIA ACUMULADO ` + nombreMesInicio.toUpperCase() + ' ' + ejercicioinicio + ' - ' + nombreMesFin.toUpperCase() + ' ' + ejerciciofin}
            className={"facturacion-maquinaria-main-screen"}
            className_main={1}
        >
            <LoaderScreen loader={loader} />
            <div className="facturacion-maquinaria-detalle-actions">
                <div
                    className="facturacion-maquinaria-actions-regresar"
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                {/* <div className="facturacion-maquinaria-actions-filtro">
                    <FiltroFacturacionMaquinaria
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                    />
                </div> */}
                <div className="buttons">
                    <button className="excel"
                    onClick={() => onGeneraExcel(ejercicioinicio, periodoinicio, ejerciciofin, periodofin, state.linea, nombreVendedor)}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button className="PDF"
                        onClick={() => 
                            onGeneraPDF(ejercicioinicio, periodoinicio, ejerciciofin, periodofin, state.linea, nombreVendedor)
                        }
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button>
                </div>
            </div>
            <div className="contador-facturas">Registros Encontrados: {facturaciones.length}</div>
            {/* <DetalleFacturacionModal
                open={openModalFacturacion}
                onClose={handleCloseModalFacturacion}
                nip={selectedNip}
            />
            <EditarModeloModal
                open={openModalEditar}
                onClose={handleCloseModalEditar}
                id={selectedID}
                nip={selectedNipEdit}
                neconomico={selectedNEconomico}
            /> */}
            <div className="facturacion-maquinaria-cliente">

                <div className="facturacion-maquinaria-cliente-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Línea</th>
                                <th>
                                    <div>Sucursal</div>
                                </th>
                                {/* <th>
                                    <div>ID Cliente</div>
                                </th> */}
                                <th>
                                    <div>Cliente</div>
                                </th>
                                <th>
                                    <div>Vendedor</div>
                                </th>
                                <th>
                                    <div>Fecha</div>
                                </th>
                                {/* <th>
                                    <div>Serie</div>
                                </th> */}
                                <th className="column-economico">
                                    <div>No. Económico</div>
                                </th>
                                <th>
                                    <div>Modelo</div>
                                </th>
                                <th>
                                    <div>Importe</div>
                                </th>
                                {/* <th>
                                    <div style={{ color: 'transparent' }}>.</div>
                                </th> */}
                                {/* <th>
                                    <div>Costo</div>
                                </th>
                                <th>
                                    <div>Utilidad</div>
                                </th>
                                <th>
                                    <div>NIP</div> 
                                </th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {facturaciones.map((fac) => (
                                <tr className={fac.eliminado === 1 ? "fila-eliminada" : ""}
                                    style={{
                                        borderLeft: fac.cancelado === 1 ? "3px solid red" : "3px solid green",
                                        color: fac.eliminado === 1 ? "white" : (fac.cancelado === 1 ? "red" : "black"),
                                    }} key={getKey(fac)}>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(fac.scorecard)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(fac.sucursal)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(fac.razonsocial)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(fac.vendedor)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-center celda-eliminada" : "ta-center"}>{fac.fecha_venta}</td>
                                    <td className={fac.eliminado === 1 ? "ta-center column-economico celda-eliminada" : "ta-center column-economico"}>{fac.neconomico}</td>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(fac.modelo)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-right celda-eliminada" : "ta-right"}>{FormatMoney(fac.importe_venta, 0)}</td>
                                    {/* <td className={fac.eliminado === 1 ? "celda-eliminada" : ""}>
                                        {fac.nip !== null && fac.nip !== "S/S" ? (
                                            <div className="listado-clientes-gestionar-detalle-button">
                                                {fac.nip !== null && fac.nip !== "S/S" && (
                                                    <div className="listado-clientes-gestionar-detalle-button" style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <div
                                                            className="detalle"
                                                            onClick={() => handleOpenModalFacturacion(fac.nip)}
                                                            style={{ marginBottom: "5px" }}
                                                        >
                                                            <VisibilityIcon /> Detalle
                                                        </div>
                                                        {fac.modelo === null || fac.modelo === "" ? (
                                                            <div
                                                                className="editar"
                                                                onClick={() => handleOpenModalEditar(fac.id, fac.nip, fac.neconomico)}
                                                            >
                                                                <EditNoteIcon /> Editar
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                )}
                                            </div>
                                        ) : null}
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </PlantillaScreen>
    );
};
